<template>
<main class="main-wrapper flex-grow-1 bg-paymentBlue">
		<div class="d-flex align-items-center ">
			<div class="t-headline13 t-color-headlineBlack pda-14 flex-grow-1  fix-header-title d-flex align-items-center justify-content-center">
				<div class="font-m">{{$t('594')}}</div>
			</div>
		</div>
		<div class="divider"></div>
		<!-- subtabs -->
		<div class="container container--narrow mgt-50 pdb-50">
			<div class="t-headline5 font-m t-line-h-26 t-center">{{$t('595')}}</div>
			<div class="t-body6 font-r t-color-bodyGrayA t-center t-line-h-22 mgt-8">
				{{$t('596')}} <br>
				{{$t('589')}}
			</div>
			<div class="bg-white mgt-40">
				<div class="headerRoll position-relative ">
					<div class="bg-white position-relative h-42 z-99">
						<div class="header-shadow"></div>
					</div>
				</div>
			</div>
			<div class="pdl-24 pdr-24 receipt-wrapper position-relative bg-white pdt-7 pdb-20">
				<div class="pdt-8 t-body3 t-line-h-24 l-spacing42 font-r">{{$t('597')}}</div>
				<div class=" pdt-4 t-headline7 l-spacing6 font-m t-line-h-26">
					{{goodsName}}
				</div>
				<div class="divider mgt-32 mgb-20"></div>
				<div class="pdt-11 pdb-11" >
                    <div class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA">{{$t('598')}}</div>
                    <div class="t-body1 mgt-4 t-line-h-22 font-r">{{$moment(learningStartDatetime).format('L')}} ~ {{learningEndDatetime}}</div>
                </div>
				<div class="pdt-11 pdb-11" >
                    <div class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA">{{$t('599')}}</div>
                    <div class="t-body1 mgt-4 t-line-h-22 font-r">{{paidDate?$moment(paidDate).format('L'):''}}</div>
                </div>
			</div>
			<div class="receipt-wrapper-bottom h-20"></div>
			<div class="mgt-50">
				<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8" @click="moveLearn()" @keypress="moveLearn()" tabindex="0">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-body2 font-r">{{$t('592')}}</span>
				</button>
				<button class="mdc-button mdc-button--raised bg-secondaryBtn t-color-secondaryBtnText  b-radius4" @click="moveList()" @keypress="moveList()" tabindex="0">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-body2 font-r">{{$t('593')}}</span>
				</button>
			</div>
		</div>
		<!-- <div class="mgt-100"></div> -->
	</main>
</template>

<script>
/**
 * 구매하기 - 결제완료(수강신청) 컴포넌트(sales - Payment completed (enrollment) component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import salesApi  from '@/api/salesApi.js'
import {salesMixin} from '@/mixins/sales.js'
import {MDCRipple} from '@material/ripple'
import { utilDateMixin } from "@/mixins/dateUtil";

export default {
	mixins: [salesMixin, utilDateMixin],
	data() {
		return {
			goodsName: '',
			learningEndDatetime: '',
			learningStartDatetime: '',
			paymentPrice: '',
			totalPrice: '',
			discountPrice: '',
			currency: '',
			bankName: '',
			bankNumber: '',
			bankDepositName: '',
			deadline: '',
			paidDate: 0,
			learnerId: '',
			category: null
		}
	},

	mounted() {
		let params = {
			orderId: this.$route.params.orderId
		}
		let params2 = {
			goodsId: this.$route.params.orderId
		}
		this.setMaterialUi()
		let responseData = {}
			// salesApi.salesGoodsOrder(params2).then((response) => {
			// 	console.log(response.data.data, ' ___response.data.data')

			// }).catch((err) => {
			// 	this.$error({content: responseData.errMsg}).then(() => {})
			// })
		// get order information
		salesApi.salesOrderDetail(params).then((response) => {
			responseData = response.data.data
			//console.log(response.data.data, ' ___response.data.data')
			this.goodsName = responseData.goods.name
			let learningEndTime = Number(responseData.goods.information.learningEndDatetime || responseData.goods.information.postEndDatetime)
            this.learningEndDatetime = this.displayEndPeriod(learningEndTime);
			this.learningStartDatetime = Number(responseData.goods.information.learningStartDatetime || responseData.goods.information.postStartDatetime)
			this.deadline = Number(responseData.deadline)
			this.paymentPrice = responseData.paymentPrice
			this.totalPrice = responseData.totalPrice
			this.discountPrice = responseData.discountPrice
			this.currency = responseData.currency

			this.paidDate = responseData.paidDate
			this.category = responseData.category            

			this.learnerId = responseData.paidData.learnerId

			// if (responseData.paymentMethod === 'bank_transfer') {
			//     this.bankName = responseData.depositAccount.bank.text
			//     this.bankNumber = responseData.depositAccount.number
			//     this.bankDepositName = responseData.depositAccount.name
			// }else {
			//     this.learnerId = responseData.paidData.learnerId
			// }

		}).catch((err) => {

		})
	},

	methods: {
		// moveList(){
		// 	this.$router.push({name:'DegreeList', query:{type:'ListTotal'}});
		// },
		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},
	}

}
</script>
